import React from 'react';
import ReportConfiguration from '../reportArea/reportConfiguration/ReportConfiguration';
import DragableWrapper from 'lib/reports-analytics/features/DragableThings/DragableWrapper';
import ColumnToggleWapper from 'lib/reports-analytics/features/columnToggle/ColumnToggleWapper';
import { GoGear } from 'react-icons/go';
import { HiOutlineCreditCard } from 'react-icons/hi';
import './reportToggleContainer.scss';
import { mls } from 'lib/multilanguagesupport';
import LoadingSpinner from 'lib/visx-lib/helpers/components/LoadingSpinner';
interface reportToggleContainerProps {
  stateProps: any;
}
const ReportToggleContainer = ({ stateProps }: reportToggleContainerProps) => {
  const { isReportConfiguration, handleReportConfigToggle } = stateProps;
  return (
    <div className='reportToggleContainer'>
      <div className='toggleButtonContainer'>
        <div className='toggleButtonDiv'>
          <div
            className={
              isReportConfiguration ? 'toggleButton style active' : 'toggleButton style disable'
            }
            onClick={() => handleReportConfigToggle(true)}
          >
            <div className='iconDiv'>
              <GoGear />
            </div>
            {mls('Report Configuration')}
          </div>
          <div
            className={
              !isReportConfiguration ? 'toggleButton build active' : 'toggleButton build disable'
            }
            onClick={() => handleReportConfigToggle(false)}
          >
            <div className='iconDiv'>
              <HiOutlineCreditCard />
            </div>
            {mls('Edit Report')}
          </div>
        </div>
      </div>
      {isReportConfiguration ? (
        <ReportConfiguration stateProps={stateProps} />
      ) : (
        <DragableWrapper stateProps={stateProps}>
          <ColumnToggleWapper stateProps={stateProps} />
        </DragableWrapper>
      )}
    </div>
  );
};

export default ReportToggleContainer;
